import { Grid, Typography } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem.jsx';
import { floor } from 'lodash';
import React from 'react';

const grandSeperator = val => {
	if(!val) {
		return "0"
	}
	
	val = val
		.toString()
		.replace(/,/g, '')
		.replace(/ /g, '');
	let parsed = parseInt(val);

	if (!isNaN(parsed)) {
		return parsed.toLocaleString().replace(/,/g, ' ');
	} else {
		return val;
	}
};

const customRow = (firstCol, secondCol, thirdCol) => {
	return (
	  <React.Fragment>
		<Grid item xs={12} sm={12} md={12}>
		  <Grid container>
			<GridItem xs={3} sm={3} md={3}>
			  {firstCol}
			</GridItem>
			<GridItem xs={2} sm={2} md={2}>
			  {secondCol}
			</GridItem>
			<GridItem xs={2} sm={2} md={2}>
			  {thirdCol}
			</GridItem>
			<GridItem xs={5} sm={5} md={5}>
			  
			</GridItem>
		  </Grid>
		</Grid>
	  </React.Fragment>
	);
  };

const ProvisionDeath = props => {
	const provision = props.state.result.deathProvision;
	

	return (
		<React.Fragment>
			
			<Grid
				direction="column"
				style={{ marginTop: '20px', marginBottom: '20px' }}
			>
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Provision for dependants: </strong>
					</Typography>,
					null,
					<Typography style={{ paddingTop: '5px' }}>
						<strong>
							R {grandSeperator(provision.provision.capitalLiquidity)}
						</strong>
					</Typography>
				)}

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						Surplus/deficit
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(provision.liquidity)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						- Surplus to other
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(provision.surplusToOther)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						- Capital Need
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(provision.capitalNeed)}
					</Typography>,
					null
				)}

				

				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						+ Policy to spouse or dependants
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(provision.provision.policies)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						+ Cash to spouse or dependants
					</Typography>,
					<Typography style={{ paddingTop: '5px' }}>
						R {grandSeperator(provision.provision.cashToSpouse)}
					</Typography>,
					null
				)}
				{customRow(
					<Typography style={{ paddingTop: '5px' }}>
					<strong>
						{" "}
					</strong>
				</Typography>,
					null,
					null
				)}{customRow(
					<Typography style={{ wordWrap: 'break-word', paddingTop: '5px' }}>
						<strong>Months Provisioned For: </strong>
					</Typography>,
					null,
					
					<Typography style={{ paddingTop: '5px' }}>
						{String(props.state.result.deathProvision.monthsProvisioned).includes(">") == false &&
							<strong>
								{floor(props.state.result.deathProvision.monthsProvisioned/12)} years and {props.state.result.deathProvision.monthsProvisioned%12} {" "}  Months
							</strong>
						}
						{String(props.state.result.deathProvision.monthsProvisioned).includes(">") == true &&
							<strong>
								More than 60 Years
							</strong>
						}
						
					</Typography>
				)}
			</Grid>

			<Grid container className="fnaGridHeading">
        <GridItem xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Income Need At Death</strong>
          </Typography>
        </GridItem>

        <GridItem xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Monthly Amount</strong>
          </Typography>
        </GridItem>
        <GridItem item xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Anual Increase</strong>
          </Typography>
        </GridItem>
		<GridItem item xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Years Needed</strong>
          </Typography>
        </GridItem>
      </Grid>
      <Grid direction="column" className="fnaGridBody">
        {props.state.needs.incomeNeeds.map((e, i) => {
          
           
          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={i % 2 === 0 ? "" : "disabledRow"}
            >
              <Grid container className="fnaGridBodyRow">
                <GridItem xs={3} sm={3} md={3}>
                  <Typography
                    style={{ wordWrap: "break-word", paddingTop: "5px" }}
                  >
                    {e.incomeStream}
                  </Typography>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    R {grandSeperator(e.mounthlyAmount.toString())}
                  </Typography>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    {e.annualIncrease}%
                  </Typography>
                </GridItem>
				<GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    {e.yearsPayable} Years
                  </Typography>
                </GridItem>
              </Grid>
            </Grid>
          );
        })}
        </Grid>


		<Grid container className="fnaGridHeading">
        <GridItem xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Income Provision</strong>
          </Typography>
        </GridItem>

        <GridItem xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Monthly Amount</strong>
          </Typography>
        </GridItem>
        <GridItem item xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Anual Increase</strong>
          </Typography>
        </GridItem>
		<GridItem item xs={3} sm={3} md={3}>
          <Typography variant="subheading">
            <strong>Years Receivable</strong>
          </Typography>
        </GridItem>
      </Grid>
      <Grid direction="column" className="fnaGridBody">
        {props.state.needs.incomeStreams.map((e, i) => {
          
           
          return (
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={i % 2 === 0 ? "" : "disabledRow"}
            >
              <Grid container className="fnaGridBodyRow">
                <GridItem xs={3} sm={3} md={3}>
                  <Typography
                    style={{ wordWrap: "break-word", paddingTop: "5px" }}
                  >
                    {e.incomeStream}
                  </Typography>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    R {grandSeperator(e.mounthlyAmount.toString())}
                  </Typography>
                </GridItem>
                <GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    {e.annualIncrease}%
                  </Typography>
                </GridItem>
				<GridItem xs={3} sm={3} md={3}>
                  <Typography style={{ paddingTop: "5px" }}>
                    {e.yearsPayable} Years
                  </Typography>
                </GridItem>
              </Grid>
            </Grid>
          );
        })}
        </Grid>

		</React.Fragment>
	);
};

export default ProvisionDeath;



// WEBPACK FOOTER //
// ./src/views/Fna/ResultsPage/results/DeathProv.jsx